import { ElMessage, ElMessageBox } from "element-plus";
import { useNuxtApp } from "#app";
// 基础 URL
let baseURL = "/devApi/";
if (process.env.NODE_ENV === "production") {
  baseURL = "https://api.modulemotion.com/";
}
const getQs = (data: any) => {
  const arr = [];
  for (const key in data) {
    arr.push(`${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`);
  }
  return arr.join("&");
};

interface Options {
  method?: string; //方法类型
  body?: any;
  showLoading?: boolean; //是否显示加载中
  noErrorMsg?: boolean; //是否显示错误提示
}

/**
 * 封装请求函数
 * @param url 请求地址
 * @param options 请求参数
 * @returns
 */
const request = (url: string, options: Options = {}): Promise<Result> => {
  let loadingInstance = null;
  if (options.showLoading) {
    loadingInstance = ShowLoading();
  }
  const nuxtApp = useNuxtApp();

  options.body = getQs(options.body);
  // GET 请求将参数拼接到 URL 中
  if (options.method === "GET") {
    url += "?" + options.body;
    delete options.body;
  }
  interface Config {
    baseURL: string; //基础URL
    onRequest: (options: any) => void; //请求前的拦截器
    onResponse: (response: any) => void; //响应后的拦截器
    onResponseError: (response: any) => void; //响应错误的拦截器
  }
  const config: Config = {
    baseURL,
    onRequest({ options }: { options: any }) {
      options.headers = {
        ...options.headers,
      };
      if (url.indexOf("upload/image") == -1) {
        options.headers["content-type"] = "application/x-www-form-urlencoded";
      }
    },
    onResponse({ response }: { response: any }) {
      if (loadingInstance) {
        loadingInstance.close();
      }
      if (response.status >= 200 && response.status < 300) {
        const data = response._data;

        if (data && data.errcode != 0) {
          const message = data.message || "未知错误";
          if (import.meta.client) {
            if (!options.noErrorMsg) {
              ElMessage.error(message);
            }
          } else {
            // 服务端跳转错误信息页面
            nuxtApp.runWithContext(() => {
              navigateTo({
                path: "/error",
                query: {
                  code: data.errcode,
                  message,
                },
              });
            });
          }
        }
      }
    },
    onResponseError({ response }: { response: any }) {
      if (loadingInstance) {
        loadingInstance.close();
      }
      const data = response._data;
      const message = data && data.message ? data.message : "未知错误";
      if (import.meta.client) {
        // 客户端错误提示
        ElMessage({
          message,
          type: "error",
        });
      } else {
        // 服务端跳转错误信息页面
        nuxtApp.runWithContext(() => {
          navigateTo({
            path: "/error",
            query: {
              code: data && data.errcode ? data.errcode : "未知错误码",
              message,
            },
          });
        });
      }
    },
    ...options,
  };

  if (import.meta.server) {
    return new Promise((resolve, reject) => {
      useFetch(url, config)
        .then((res: any) => {
          resolve(res.data.value);
        })
        .catch((err) => {
          reject(err);
        });
    });
  } else {
    return $fetch(url, config);
  }
};

interface ApiOptions {
  showLoading?: boolean; //是否显示加载中
  noErrorMsg?: boolean; //是否显示错误提示
  [key: string]: any;
}
interface Result {
  errcode: number;
  message: string;
  data: any;
}

/**
 * 封装 GET 请求
 * @param url
 * @param params
 * @param options
 * @returns
 */
export const GetApi = (
  url: string,
  params: object = {},
  options?: ApiOptions
): Promise<Result> => {
  options = options || {};

  return request(url, {
    body: params,
    method: "GET",
    ...options,
  });
};

/**
 * 封装 POST 请求
 * @param url
 * @param body
 * @param options
 * @returns
 */
export const PostApi = (
  url: string,
  body: any = {},
  options?: ApiOptions
): Promise<Result> => {
  return request(url, {
    method: "POST",
    body,
    ...options,
  });
};
